import React from 'react';
import { DownloadableCloudAccountAdd } from './DownloadableCloudAccountAdd';
import { DownloadableCloudAccountEdit } from './DownloadableCloudAccountEdit';

/**
 * Downloadable Cloud Account - Orchestrator Component
 * Routes to Add or Edit mode based on isEditMode prop
 * Handles vSphere, OpenShift, NC2, HPE VME, and Hyper-V
 */
export const DownloadableCloudAccount = ({ isEditMode, ...props }) => {
    return isEditMode ? <DownloadableCloudAccountEdit {...props} /> : <DownloadableCloudAccountAdd {...props} />;
};
